const AAVE_KOVAN = '0xb597cd8d3217ea6477232f9217fa70837ff667af'
// const AAVE_VPOOL = '0x24d2898Bad08d3a62aF5769519BC2d9687fBc425'
// const AAVE_VPOOL = '0xEbcc6a16302b72842724e9E6bc26FE243def99b7'
const AAVE_VPOOL = '0xFD10C5390cc4617aA85d34D2E5e72F50A5C6D3ac'

export { AAVE_VPOOL, AAVE_KOVAN }
